import { defineStore } from 'pinia'
import { getSettings } from '@/api/public'
import { ApplicationSetting } from '@/types'
import { useAuthStore } from './auth'
import { useDealersStore } from './dealers'

type AppState = {
  fetchingResources: number
  error: string | null
  settings: ApplicationSetting | null
  defaultLanguage: string
  currentSearchOrdersFilter: string
  searchOrdersFilters: Array<string>
  showOrders: boolean
  showOrdersItaly: boolean
  showOrdersUSA: boolean
}

export const useAppStore = defineStore('app', {
  state: (): AppState => ({
    fetchingResources: 0,
    error: null,
    settings: null,
    defaultLanguage: 'en',
    currentSearchOrdersFilter: 'ORDER',
    searchOrdersFilters: ['ORDER', 'CLIENT', 'DATE'],
    showOrders: false,
    showOrdersItaly: true,
    showOrdersUSA: false
  }),
  getters: {
    isFetching: state => state.fetchingResources > 0,
    maintenanceMode: state => (state.settings ? Boolean(state.settings.maintenanceMode) : false),
    availableLanguages: () => {
      const dealersStore = useDealersStore()
      const authStore = useAuthStore()
      const langs = [{ locale: 'it', flag: 'ita' }]
      if (
        (authStore.userData && authStore.userData.market && authStore.userData.market.toUpperCase() === 'USA') ||
        (dealersStore.currentDealer &&
          dealersStore.currentDealer.market &&
          dealersStore.currentDealer.market.toUpperCase() === 'USA')
      ) {
        langs.push({ locale: 'en', flag: 'usa' })
      } else {
        langs.push({ locale: 'en', flag: 'gbr' })
      }
      return langs
    }
  },
  actions: {
    async boot() {
      const data = await getSettings()
      this.settings = data as ApplicationSetting
      const detectedLanguage = navigator && navigator.language ? navigator.language.split('-').shift() : null
      const availableLanguages = this.availableLanguages.map(l => l.locale)
      if (detectedLanguage && availableLanguages.includes(detectedLanguage.toLowerCase()))
        this.defaultLanguage = detectedLanguage.toLowerCase()
      return this.settings
    },
    setIsFetching(value = true) {
      if (value === true) this.fetchingResources++
      else this.fetchingResources--
    },
    selectSearchOrdersFilter(filter: string) {
      this.currentSearchOrdersFilter = filter
    },
    showOrdersToggle() {
      this.showOrders = !this.showOrders
    }
  }
})
